import { Pipe, PipeTransform } from '@angular/core';
import { AppConsts } from '../../../../shared/AppConsts';


@Pipe({
  standalone: false,
  name: 'dateConvertPipe'
})
export class DateConvertPipePipe implements PipeTransform {

    transform(date: Date): string {
        let dateFormat = AppConsts.dateFormatList.find(r => r.id === AppConsts.dateFormatId).name;
        const dateFormatArray = dateFormat.split("/");
        let dateArray = dateFormatArray.map(r => {
            if (r === "MM") {
                return date.getMonth() + 1
            }
            else if (r === "DD") {
                return date.getDay()
            }

            else if (r === "YYYY") {
                return date.getFullYear()
            }
        })
        return dateArray.join("/");
    }


}
